import React from "react";
import style from "./Segundaparte.module.css";

// Ajustá rutas si las tenés en otra carpeta
import icon1 from "../../../../utils/images/smartiot_1.svg";
import icon2 from "../../../../utils/images/smartiot_2.svg";
import icon3 from "../../../../utils/images/smartiot_3.svg";
import icon4 from "../../../../utils/images/smartiot_4.svg";

const SegundaParte = ({ t }) => {
  return (
    <section className={style.container}>
      <h2 className={style.titulo}>
        {t("Products.SmartIOT.SecondPart.title")}
      </h2>

      <div className={style.grid}>
        <div className={style.item}>
          <img className={style.icon} src={icon1} alt={t("Products.SmartIOT.SecondPart.text")} />
          <h3 className={style.itemTitle}>{t("Products.SmartIOT.SecondPart.text")}</h3>
          <p className={style.itemText}>{t("Products.SmartIOT.SecondPart.text2")}</p>
        </div>

        <div className={style.item}>
          <img className={style.icon} src={icon2} alt={t("Products.SmartIOT.SecondPart.text3")} />
          <h3 className={style.itemTitle}>{t("Products.SmartIOT.SecondPart.text3")}</h3>
          <p className={style.itemText}>{t("Products.SmartIOT.SecondPart.text4")}</p>
        </div>

        <div className={style.item}>
          <img className={style.icon} src={icon3} alt={t("Products.SmartIOT.SecondPart.text5")} />
          <h3 className={style.itemTitle}>{t("Products.SmartIOT.SecondPart.text5")}</h3>
          <p className={style.itemText}>{t("Products.SmartIOT.SecondPart.text6")}</p>
        </div>

        <div className={style.item}>
          <img className={style.icon} src={icon4} alt={t("Products.SmartIOT.SecondPart.text7")} />
          <h3 className={style.itemTitle}>{t("Products.SmartIOT.SecondPart.text7")}</h3>
          <p className={style.itemText}>{t("Products.SmartIOT.SecondPart.text8")}</p>
        </div>
      </div>
    </section>
  );
};

export default SegundaParte;
